'use strict';

module.exports = /([{}])\1|{([^}]*)}|(%)%|(%(\w*))/g;